import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CredentialService } from 'src/app/services/core/credential/credential.service';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css']
})
export class CompanyComponent implements OnInit,OnDestroy {
  companyId: any;
  companyForm!: FormGroup;
  approvalForm!: FormGroup;
  @Input() companyDetailObj:any
  submitted = false;

  constructor(
    private fb: FormBuilder,
    private credentialService: CredentialService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.activatedRoute.params
      .subscribe((params) => {
        this.companyId = params["companyId"];
        if (this.companyId) {
          this.getCompanybyId();
        }
      });
    this.companyForm = this.fb.group({
      transportationCompanyName: [''],
      name: [''],
      phoneNumber: [''],
      secondaryPhoneNumber: [''],
      hoursofOperation: [''],
      email: [''],
      provideService: [''],
      timeZone: [''],
      profileImageURL: [''],
      webURL: [''],
      signup: [''],

      address: this.fb.group({
        name: [''],
        coords: [[]],
        city: [''],
        state: [''],
      }),

      owner: this.fb.group({
        firstName: [''],
        lastName: [''],
        phoneNumber: [''],
        email: [''],
        driverLicenseImage: [''],

        address: this.fb.group({
          name: [''],
          coords: [[]],
          city: [''],
          state: ['']
        })
      }),

      documents: this.fb.group({
        hIPAATrainingCertificateImage: [''],
        hIPAATrainingDate: [''],
        fraudWasteAndAbuseCertificateImage: [''],
        fraudWasteAndAbuseCertificateDate: [''],
        nonDisclosureAgreementImage: [''],
        transportationProviderAgreementImage: [''],
        w9Image: [''],
        disclosureofOwnershipImage: [''],
        eFTFormImage: [''],
        voidedCheckImage: [''],
        driverScheduleImage: [''],
        vehicleScheduleImage: [''],
        vehicleForHireLicenseImage: [''],
      }),

      insurance: this.fb.group({
        generalLiabilityInsuranceImage: [''],
        generalLiabilityInsuranceDate: [''],
        autoLiabilityInsuranceImage: [''],
        autoLiabilityInsuranceDate: [''],
        workerCOIImage: [''],
        workerCOIImageExpireDate: ['']
      }),

      bankDetails: this.fb.group({
        name: [''],
        accountNumber: [''],
        routingNumber: [''],
      }),
    });

    // .....
    this.approvalForm = this.fb.group({
      isName: [false],
      isTimeZone: [false],
      isProfileImageURL: [false],
      isTransportationCompanyName: [false],
      isProvideService: [false],
      isPhoneNumber: [false],
      isSecondaryPhoneNumber: [false],
      isEmail: [false],
      isHoursofOperation: [false],
      address: this.fb.group({
        isName: [false],
        isCity: [false],
        isState: [false],
      }),

      owner: this.fb.group({
        isFirstName: [false],
        isLastName: [false],
        isPhoneNumber: [false],
        isEmail: [false],
        isDriverLicenseImage: [false],
        address: this.fb.group({
          isName: [false],
          isCity: [false],
          isState: [false],
        })
      }),

      documents: this.fb.group({
        isHIPAATrainingCertificateImage: [false],
        isHIPAATrainingDate: [false],
        isFraudWasteAndAbuseCertificateImage: [false],
        isFraudWasteAndAbuseCertificateDate: [false],
        isNonDisclosureAgreementImage: [false],
        isTransportationProviderAgreementImage: [false],
        isW9Image: [false],
        isDisclosureofOwnershipImage: [false],
        isEFTFormImage: [false],
        isVoidedCheckImage: [false],
        isDriverScheduleImage: [false],
        isVehicleScheduleImage: [false],
        isVehicleForHireLicenseImage: [false]
      }),

      insurance: this.fb.group({
        isGeneralLiabilityInsuranceImage: [false],
        isGeneralLiabilityInsuranceDate: [false],
        isAutoLiabilityInsuranceImage: [false],
        isAutoLiabilityInsuranceDate: [false],
        isWorkerCOIImage: [false],
        isWorkerCOIImageExpireDate: [false],
      }),

      bankDetails: this.fb.group({
        isName: [false],
        isAccountNumber: [false],
        isRoutingNumber: [false],
      }),
    })
  }

  setControls(groupName: string, controlName: string, value: any) {
    const fullPath = groupName ? `${groupName}.${controlName}` : controlName;
    const control = this.approvalForm.get(fullPath);
    if (control) {
      control.setValue(value);
      control.markAsTouched();
    }
  }

  getCompanybyId() {
    this.credentialService.getCompanyById(this.companyId).subscribe((data: any) => {
      if (data) {
        this.companyForm.patchValue({
           ...data
          }),
          this.approvalForm.patchValue({
            ...data.validationFlags
          })
      }
    })
  }

  onSubmit() {
    this.submitted = true;
    if (this.approvalForm.invalid) {
      return;
    }
    const payload = this.approvalForm.value
    this.credentialService.updateCompanyVerification(this.companyId, payload).subscribe((data: any) => {
      if (data) {
        this.router.navigateByUrl('/credentials')
      }
    })
  }
  ngOnDestroy(): void {}
}
